const translations = {
    download: 'Download Invoice',
    edit: 'Edit Invoice',
    email: 'Email Invoice',
    invoicePreview: 'Invoice Preview'
};

export default translations;
